module.exports = __webpack_public_path__ + "assets/tDbX2oqRg1oM3QBjjcaDkOr4lLz5CwOnSA-7a786c.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/tDbX2oqRg1oM3QBjjcaDkOr4lLz5CwOnSA.woff2
// module id = 862
// module chunks = 2